import React from "react";
import { Outlet } from "react-router-dom";
import Header from "./Header";
import Sidebar from "./Sidebar";

const AppShell: React.FC = () => {
    return (
        <div className="app-shell">
            <Sidebar />

            <div className="app-content-wrapper">
                <Header />

                <main className="app-main">
                    <Outlet />
                </main>
            </div>
        </div>
    );
};

export default AppShell;
